import styled from 'styled-components'

const Body = styled.div`
  width: 100%;
  min-height: ${props => (props.isGrid ? '165px' : '154px')};
  display: flex;
  flex: 1;
  flex-direction: ${props => (props.isGrid ? 'column' : 'row')};
  background: ${props => props.theme.colors.white};
  padding: ${props => (props.isGrid ? '14px 14px 12px 14px' : '14px 28px 14px 22px')};
  border: 2px solid transparent;
  color: ${props => props.theme.colors.black};
  align-items: flex-start;

  &:hover {
    text-decoration: none;
  }

  &:focus-visible {
    border-color: ${props => props.theme.colors.primary};
  }
`

export default Body
